<template>
  <div>
    <table class="teshu">
      <tbody>
        <tr>
          <th colSpan="1" rowSpan="1" width="72">产品型号</th>
          <th colSpan="2" rowSpan="1" width="144">轴输出电流</th>
          <th colSpan="1" rowSpan="1" width="257">匹配电机</th>
          <th colSpan="1" rowSpan="1" width="488">选型手册下载</th>
          <th colSpan="1" rowSpan="1" width="433">电机三维下载</th>
        </tr>
        
        <tr>
          <td colSpan="1" rowSpan="6" width="auto">CDRD-6A20-AG1</td>
          <td colSpan="1" rowSpan="2" width="auto">轴1~2</td>
          <td colSpan="1" rowSpan="2" width="auto">20</td>
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA130-11515FA1-01B12')">TDA130-11515FA1-01B12</td>
          <td colSpan="1" rowSpan="46" width="488"> 
            <a
              href="https://image.sjyuan.net.cn/img/mvb/Ha3tNSjF4W.pdf"
              target=""
              >中文版下载</a>
            <br />
            <br />
            <a
              href="https://image.sjyuan.net.cn/img/mvb/Zzbn7ehzfF.pdf"
              target=""
              >英文版下载</a>            
          </td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/K5fRZAXdA4.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>
        
        <tr>
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA130-11515FA1-11B12')">TDA130-11515FA1-11B12</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/X4cWke3CFk.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>
        
        <tr>
          <td colSpan="1" rowSpan="2" width="auto">轴3</td>
          <td colSpan="1" rowSpan="2" width="auto">10</td>
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA130-07220FA1-01B00')">TDA130-07220FA1-01B00</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/SfaXJ84EXJ.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>
        
        <tr>
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA130-07220FA1-11B00')">TDA130-07220FA1-11B00</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/tDCWcXdcYW.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>
        
        <tr>
          <td colSpan="1" rowSpan="2" width="auto">轴4~6</td>
          <td colSpan="1" rowSpan="2" width="auto">5</td>
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA130-04820FA1-01B00')">TDA130-04820FA1-01B00</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/wrnzfhyWcF.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>
        
        <tr>
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA130-04820FA1-11B00')">TDA130-04820FA1-11B00</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/WQbcYx2XMG.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>
        <!--7-->
        <tr class="bj">
          <td colSpan="1" rowSpan="14" width="auto">CDRD-6A18-A01</td>
          <td colSpan="1" rowSpan="8" width="auto">轴1~2</td>
          <td colSpan="1" rowSpan="8" width="auto">18</td>
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA130-08315FA1-01B12')">TDA130-08315FA1-01B12</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/5GFeS5krBS.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>
        
        <tr class="bj">
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA130-08315FA1-11B12')">TDA130-08315FA1-11B12</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/WthSj8j8RW.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>
        
        <tr class="bj">
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA130-11515FA1-01B12')">TDA130-11515FA1-01B12</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/K5fRZAXdA4.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>
        
        <tr class="bj">
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA130-11515FA1-11B12')">TDA130-11515FA1-11B12</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/X4cWke3CFk.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>
        
        <tr class="bj">
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA130-09620FA1-01B00')">TDA130-09620FA1-01B00</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/xQexdp6X8p.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>
        
        <tr class="bj">
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA130-09620FA1-11B00')">TDA130-09620FA1-11B00</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/pBbpab2i6c.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>
        
        <tr class="bj">
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA130-14320FA1-01B00')">TDA130-14320FA1-01B00</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/jsRQsT8kmy.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>
        
        <tr class="bj">
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA130-14320FA1-11B00')">TDA130-14320FA1-11B00</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/XtpFZ8pXfc.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>
        
        <tr class="bj">
          <td colSpan="1" rowSpan="2" width="auto">轴3</td>
          <td colSpan="1" rowSpan="2" width="auto">10</td>
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA130-07220FA1-01B00')">TDA130-07220FA1-01B00</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/SfaXJ84EXJ.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>

        <tr class="bj">
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA130-07220FA1-11B00')">TDA130-07220FA1-11B00</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/tDCWcXdcYW.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>

        <tr class="bj">
          <td colSpan="1" rowSpan="4" width="auto">轴4~6</td>
          <td colSpan="1" rowSpan="4" width="auto">5</td>
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA130-04820FA1-01B00')">TDA130-04820FA1-01B00</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/wrnzfhyWcF.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>

        <tr class="bj">
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA130-04820FA1-11B00')">TDA130-04820FA1-11B00</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/WQbcYx2XMG.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>

        <tr class="bj">
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA080-02430FA0-01BA0')">TDA080-02430FA0-01BA0</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/XcwiMMjrA7.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>

        <tr class="bj">
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA080-02430FA0-11BA0')">TDA080-02430FA0-11BA0</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/j46drMwdiN.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>
        <!--21 CDRD-6A08-A01-->
        <tr>
          <td colSpan="1" rowSpan="8" width="auto">CDRD-6A08-A01</td>
          <td colSpan="1" rowSpan="2" width="auto">轴1~2</td>
          <td colSpan="1" rowSpan="2" width="auto">8</td>
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA080-02430FA0-01BA0')">TDA080-02430FA0-01BA0</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/XcwiMMjrA7.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>

        <tr>
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA080-02430FA0-11BA0')">TDA080-02430FA0-11BA0</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/j46drMwdiN.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>

        <tr>
          <td colSpan="1" rowSpan="4" width="auto">轴3~4</td>
          <td colSpan="1" rowSpan="4" width="auto">5</td>
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA130-04820FA1-01B00')">TDA130-04820FA1-01B00</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/wrnzfhyWcF.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>

        <tr>
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA130-04820FA1-11B00')">TDA130-04820FA1-11B00</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/WQbcYx2XMG.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>

        <tr>
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA080-02430FA0-01BA0')">TDA080-02430FA0-01BA0</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/XcwiMMjrA7.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>

        <tr>
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA080-02430FA0-11BA0')">TDA080-02430FA0-11BA0</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/j46drMwdiN.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>

        <tr>
          <td colSpan="1" rowSpan="2" width="auto">轴5~6</td>
          <td colSpan="1" rowSpan="2" width="auto">3</td>
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA060-01330FA0-01BA0')">TDA060-01330FA0-01BA0</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/W3SHYPJfAh.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>

        <tr>
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA060-01330FA0-11BA0')">TDA060-01330FA0-11BA0</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/AK8YrcKhAK.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>
        <!--CDRD-6A08-A01-->

        <tr  class="bj">
          <td colSpan="1" rowSpan="6" width="auto">CDRD-6A05-A01</td>
          <td colSpan="1" rowSpan="4" width="auto">轴1~3</td>
          <td colSpan="1" rowSpan="4" width="auto">5</td>
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA130-04820FA1-01B00')">TDA130-04820FA1-01B00</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/wrnzfhyWcF.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>

        <tr  class="bj">
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA130-04820FA1-11B00')">TDA130-04820FA1-11B00</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/WQbcYx2XMG.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>

        <tr  class="bj">
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA080-02430FA0-01BA0')">TDA080-02430FA0-01BA0</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/XcwiMMjrA7.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>

        <tr  class="bj">
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA080-02430FA0-11BA0')">TDA080-02430FA0-11BA0</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/j46drMwdiN.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>

        <tr  class="bj">
          <td colSpan="1" rowSpan="2" width="auto">轴4~6</td>
          <td colSpan="1" rowSpan="2" width="auto">3</td>
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA060-01330FA0-01BA0')">TDA060-01330FA0-01BA0</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/W3SHYPJfAh.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>

        <tr class="bj">
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA060-01330FA0-11BA0')">TDA060-01330FA0-11BA0</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/AK8YrcKhAK.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>
        <!--CDRD-4A05-A11-->
        <tr>
          <td colSpan="1" rowSpan="12" width="auto">CDRD-4A05-A11</td>
          <td colSpan="1" rowSpan="4" width="auto">轴1~3</td>
          <td colSpan="1" rowSpan="4" width="auto">5</td>
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA130-04820FA1-01B00')">TDA130-04820FA1-01B00</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/wrnzfhyWcF.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>

        <tr>
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA130-04820FA1-11B00')">TDA130-04820FA1-11B00</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/WQbcYx2XMG.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>
        <tr>
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA080-02430FA0-01BA0')">TDA080-02430FA0-01BA0</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/XcwiMMjrA7.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>
        <tr>
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA080-02430FA0-11BA0')">TDA080-02430FA0-11BA0</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/j46drMwdiN.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>
        <tr>
          <td colSpan="1" rowSpan="8" width="auto">轴4</td>
          <td colSpan="1" rowSpan="8" width="auto">2</td>
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA040-P1630FA0-01BA0')">TDA040-P1630FA0-01BA0</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/hjc2sYz2Bp.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>
        <tr>
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA040-P1630FA0-11BA0')">TDA040-P1630FA0-11BA0</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/pNyAYbJnGa.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>
        <tr>
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA040-P3230FA0-01BA0')">TDA040-P3230FA0-01BA0</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/nxfePNe6kr.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>
        <tr>
          <td colSpan="1" rowSpan="1" width="auto"  class="tourl" @click="goto('TDA040-P3230FA0-11BA0')">TDA040-P3230FA0-11BA0</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/7zY5dsAwS4.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>
        <tr>
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA040-P4830FA0-01BA0')">TDA040-P4830FA0-01BA0</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/khZNb73SQX.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>
        <tr>
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA040-P4830FA0-11BA0')">TDA040-P4830FA0-11BA0</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/nAxcXF23yh.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>
        <tr>
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA060-P6430FA0-01BA0')">TDA060-P6430FA0-01BA0</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/TZ5EcxrpSZ.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>
        <tr>
          <td colSpan="1" rowSpan="1" width="auto" class="tourl" @click="goto('TDA060-P6430FA0-11BA0')">TDA060-P6430FA0-11BA0</td>
          <td colSpan="1" rowSpan="1" width="auto">
            <a
              href="https://image.sjyuan.net.cn/img/mvb/mSF2zhr3Y2.zip"
              target=""
              >下载</a
            >
          </td>
        </tr>
      </tbody>
    </table>
    <p><br /></p>
  </div>
</template>
  <script>
export default {
  components: {},
  data() {
    return {};
  },
  mounted() {
    
  },
  methods: {
    goto(smodel){
          this.$emit("goto",smodel)  
    }
  },
};
</script>
  <!--声明语言，并且添加scoped-->
  <style  scoped>
.teshu {
  width: 100%;
  text-align: center;
  border: 1px solid #cccccc;
  font-size: 14px;
}
.teshu tr td,
.teshu tr th {
  width: auto !important;
  border-right: 1px solid #cccccc;
  border-bottom: 1px solid #cccccc;
}

.teshu tr th {
  background-color: #2655ae;
  color: #fff;
  height: 48px;
  font-weight: 400;
}
.teshu tr td {
  height: 30px;
  color: #666666;
}
.teshu tr td a { 
  color: #666666;
}
.teshu tr td  a:hover,
.teshu .tourl:hover {
  cursor: pointer;
  color: #2655ae;
  text-decoration: underline;
}
/* .teshu tr:nth-child(2n){
  background-color: red;
} */
.teshu .bj{
  background-color: #e8f1ff;
}
</style>


// WEBPACK FOOTER //
// src/components/goods/GoodsDownItem.vue